/** @jsx h */
import { h } from 'preact'

const SwipeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='56'
      height='80'
      viewBox='0 0 56 80'
    >
      <g fill='none' fillRule='evenodd' stroke='#FFF' strokeWidth='2'>
        <path
          d='M22.693 22.726L46.576 2.802a3.953 3.953 0 015.549.48 3.927 3.927 0 01-.453 5.532L35.985 22.147h0l2.228-2.01a3.802 3.802 0 015.448.364 3.88 3.88 0 01-.483 5.496l-2.87 2.381h0l1.877-1.555a3.966 3.966 0 015.556.489 4.034 4.034 0 01-.383 5.611l-2.668 2.394h0l.622-.59a2.93 2.93 0 014.567.686 4.66 4.66 0 01-.985 5.797c-3.752 3.289-7.03 5.866-9.834 7.73-3.487 2.319-9.066 4.425-16.738 6.317M9.814 34.24c.049-1.993 2-6.845 5.856-14.555 3.855-7.71 6.855-12.97 9-15.781 3.894.912 5.374 2.943 4.44 6.09a614.378 614.378 0 00-2.707 9.4'
          transform='translate(-11.463) rotate(-66 56.033 35.658)'
        />
        <g
          strokeLinecap='round'
          transform='translate(-11.463) translate(19.463 3)'
        >
          <path
            strokeLinejoin='round'
            d='M-2.043 11.487L5.08 4.52 12.126 11.412'
            transform='scale(1 -1) rotate(-77 -5.02 0)'
          />
          <path d='M1.738 8.717c13.21-5.811 27.233-6.185 42.069-1.12' />
        </g>
      </g>
    </svg>
  )
}

export default SwipeIcon
